import { render, staticRenderFns } from "./NftUserTable.vue?vue&type=template&id=3ae4e587&scoped=true&"
import script from "./NftUserTable.vue?vue&type=script&lang=js&"
export * from "./NftUserTable.vue?vue&type=script&lang=js&"
import style0 from "./NftUserTable.vue?vue&type=style&index=0&id=3ae4e587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4e587",
  null
  
)

export default component.exports